import React, { useState } from 'react';
import classNames from 'classnames';

/* Validation */
import { Formik } from 'formik';
import validationSchema from './formConfig';

/* Gjensidige Core 20 Imports */
import utils from '@gjensidige/core-utilities-css';

/* Gjensidige Core 30 Imports */
import { Alert } from '@gjensidige/core-components/lib/alerts/default';
import { Container, Row, Col } from '@gjensidige/nci-core-grid';
import { Input } from '@gjensidige/core-components/lib/forms/input';
import { Dropdown } from '@gjensidige/core-components/lib/forms/dropdown';

import { Title, Text } from '@gjensidige/nci-core-typography';

/* API */
import axios from 'axios';
import { Endpoints } from '@internal/common';
import {Button} from "@gjensidige/core-components/lib/button";

const OrderGreenCard = () => {
  const [formData, setFormData] = useState({
    travelCountry: '',
    travelDate: '',
    returnDate: '',
    name: '',
    address: '',
    zipCode: '',
    city: '',
    email: '',
    registrationNumber: '',
    policyNumber: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(false);

  const onDropdownChange = (value: string) => {
    setFormData({ ...formData, travelCountry: value });
  };

  const sendFormData = () => {
    setApiError(false);
    axios
      .post(Endpoints.OrderGreenCard, formData)
      .then(() => setSubmitted(true))
      .catch(() => setApiError(true));
  };

  const travelCountryDropdownOptions = [
    'Albanien',
    'Israel',
    'Makedonien',
    'Marokko',
    'Montenegro',
    'Serbien',
    'Tunesien',
    'Tyrkiet',
    'Ukraine'
  ];

  return (
    <Container className={utils['mt-2']}>
      {submitted ? (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="success"
            showIcon
            title="Tak for din bestilling!"
            text="Vi sender kortet til dig, så du har det indenfor cirka en uge."
            className={utils['mb-3']}
          />
        </Row>
      ) : (
        <Formik
          enableReinitialize
          initialValues={{
            travelCountry: formData.travelCountry,
            travelDate: formData.travelDate,
            returnDate: formData.returnDate,
            name: formData.name,
            address: formData.address,
            zipCode: formData.zipCode,
            city: formData.city,
            email: formData.email,
            registrationNumber: formData.registrationNumber,
            policyNumber: formData.policyNumber
          }}
          validationSchema={validationSchema(formData)}
          onSubmit={() => {
            sendFormData();
          }}
        >
          {(props) => {
            const {
              handleSubmit,
              handleBlur,
              setFieldValue,
              touched,
              errors
            } = props;
            return (
              <form onSubmit={handleSubmit} className={utils['pb-3']}>
                <Row
                  className={classNames(
                    utils['mb-3'],
                    utils['justify-content-center']
                  )}
                >
                  <Col lg={6}>
                    <Title tag="h4">Bestil grønt kort</Title>
                    <Text size="p">
                      Bestil kun det grønne kort hvis du skal til et land, hvor
                      det er påkrævet Skal du rejse til et af landene i listen
                      nedenfor, skal du bestille og medbringe det originale
                      grønne kort.
                    </Text>
                    <br />
                    <Text>* Påkrævede felter</Text>
                  </Col>
                </Row>
                <Row className={utils['justify-content-center']}>
                  <Col lg={6}>
                    <Dropdown
                      name="travelCountry"
                      id="travel-country"
                      labelText="Hvilket land skal du rejse til? *"
                      className={utils['pb-2']}
                      options={travelCountryDropdownOptions.map((option) => {
                        return { labelText: option, value: option };
                      })}
                      value={formData.travelCountry}
                      onChange={(value: string) => {
                        onDropdownChange(value);
                      }}
                      onBlur={handleBlur}
                      invalid={
                        !!(touched.travelCountry && errors.travelCountry)
                      }
                      errorText={errors.travelCountry}
                    />
                    <Input
                      id="travel-date"
                      labelText="Hvilken dato skal du rejse? *"
                      name="travelDate"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('travelDate', event.target.value);
                        setFormData({
                          ...formData,
                          travelDate: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.travelDate && errors.travelDate)}
                      errorText={errors.travelDate}
                      value={formData.travelDate}
                    />
                    <Input
                      id="return-date"
                      labelText="Hvilken dato er du tilbage i Danmark igen? *"
                      name="returnDate"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('returnDate', event.target.value);
                        setFormData({
                          ...formData,
                          returnDate: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.returnDate && errors.returnDate)}
                      errorText={errors.returnDate}
                      value={formData.returnDate}
                    />
                    <Input
                      id="name"
                      labelText="Navn *"
                      name="name"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('name', event.target.value);
                        setFormData({ ...formData, name: event.target.value });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.name && errors.name)}
                      errorText={errors.name}
                      value={formData.name}
                    />
                    <Input
                      id="address-id"
                      labelText="Adresse *"
                      name="address"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('address', event.target.value);
                        setFormData({
                          ...formData,
                          address: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.address && errors.address)}
                      errorText={errors.address}
                      value={formData.address}
                    />
                    <Row>
                      <Col lg={6} md={6}>
                        <Input
                          id="zip-code"
                          labelText="Postnummer *"
                          name="zipCode"
                          className={utils['pb-2']}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setFieldValue('zipCode', event.target.value);
                            setFormData({
                              ...formData,
                              zipCode: event.target.value
                            });
                          }}
                          onBlur={handleBlur}
                          invalid={!!(touched.zipCode && errors.zipCode)}
                          errorText={errors.zipCode}
                          value={formData.zipCode}
                        />
                      </Col>
                      <Col lg={6} md={6}>
                        <Input
                          id="city"
                          labelText="By *"
                          name="city"
                          className={utils['pb-2']}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setFieldValue('city', event.target.value);
                            setFormData({
                              ...formData,
                              city: event.target.value
                            });
                          }}
                          onBlur={handleBlur}
                          invalid={!!(touched.city && errors.city)}
                          errorText={errors.city}
                          value={formData.city}
                        />
                      </Col>
                    </Row>
                    <Input
                      id="email"
                      labelText="E-mail *"
                      name="email"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('email', event.target.value);
                        setFormData({
                          ...formData,
                          email: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.email && errors.email)}
                      errorText={errors.email}
                      value={formData.email}
                    />
                    <Input
                      id="registration-number"
                      labelText="Registreringsnummer *"
                      name="registrationNumber"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('registrationNumber', event.target.value);
                        setFormData({
                          ...formData,
                          registrationNumber: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={
                        !!(
                          touched.registrationNumber &&
                          errors.registrationNumber
                        )
                      }
                      errorText={errors.registrationNumber}
                      value={formData.registrationNumber}
                    />
                    <Input
                      id="policy-number"
                      labelText="Policenummer *"
                      name="policyNumber"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('policyNumber', event.target.value);
                        setFormData({
                          ...formData,
                          policyNumber: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.policyNumber && errors.policyNumber)}
                      errorText={errors.policyNumber}
                      value={formData.policyNumber}
                    />
                    <Button variant={'primary'} type="submit" flexible>
                      Bestil grøn kort
                    </Button>
                  </Col>
                </Row>
              </form>
            );
          }}
        </Formik>
      )}
      {apiError && (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="error"
            showIcon
            text="Der skete en fejl ved indsendelse. Prøv venligst igen senere"
            title="Der skete en fejl."
            className={utils['mb-3']}
          />
        </Row>
      )}
    </Container>
  );
};

export default OrderGreenCard;
